import { render, staticRenderFns } from "./AwardSection.vue?vue&type=template&id=360c9c0e&scoped=true&"
import script from "./AwardSection.vue?vue&type=script&lang=js&"
export * from "./AwardSection.vue?vue&type=script&lang=js&"
import style0 from "./AwardSection.vue?vue&type=style&index=0&id=360c9c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c9c0e",
  null
  
)

export default component.exports